import { RootState } from "../rootReducer"

export const selectIsOmniLoading = (state: RootState) => Object.keys(state.app.loadingProcesses).length > 0
